import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpRequestService} from './../../shared/services/http-request.service';
import {SelectedPeoplesToSurvey, PeopleFilterModel} from './../../models/people/people.model';
import {Observable} from "rxjs";
import {ResponseContentType} from "@angular/http";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ObservableInput} from "rxjs/Observable";

@Injectable()
export class PeopleService {

  private getPeopleSearchPDUrl = environment.apiUrl + '/People/GetPeopleSearchPDModel';
  private addPeopleToExistingSurveyUrl = environment.apiUrl + '/People/AddPeopleToExistingSurvey';
  private createNewSurveyFromSelectionUrl = environment.apiUrl + '/People/CreateNewSurveyFromSelection';
  private filterPeopleUrl = environment.apiUrl + '/People/FilterPeople';
  private filterPeopleCountUrl = environment.apiUrl + '/People/FilterPeopleCount';
  private csvUploadUrl = environment.apiUrl + '/People/CsvImport';
  private getPeopleReportModelUrl = environment.apiUrl + '/People/GetPeopleReportModel';
  private deletePeopleUrl = environment.apiUrl + '/People/DeletePeople';


  constructor(private http: HttpRequestService, private httpClient: HttpClient) {
  }

  getPeopleSearchPD() {
    return this.http.get(this.getPeopleSearchPDUrl, false);
  }

  addPeopleToExistingSurvey(data: SelectedPeoplesToSurvey) {
    return this.http.post(this.addPeopleToExistingSurveyUrl, data, true, 'You have successfully added peoples to existing survey');
  }

  createNewSurveyFromSelection(data: SelectedPeoplesToSurvey) {
    return this.http.post(this.createNewSurveyFromSelectionUrl, data, true, 'You have successfully added peoples to new survey');
  }

  filterPeople(data: PeopleFilterModel) {
    return this.http.post(this.filterPeopleUrl, data, false);
  }

  filterPeopleCount(data: PeopleFilterModel) {
    return this.http.post(this.filterPeopleCountUrl, data, false);
  }

  csvUpload(files) {
    // postMultipart(url: string, data: any, files: File[], showSuccessToast?: boolean, toastMessage?: string) {
    return this.http.postMultipart(this.csvUploadUrl, null, files);
  }

  getPeopleReportModel(userId) {
    return this.http.get(this.getPeopleReportModelUrl + '?personId=' + userId);
  }

  deletePeople(listPeopleId) {
    return this.http.post(this.deletePeopleUrl, {listPeopleId})
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/people/people.service.ts